import axios, { type AxiosRequestConfig, type Method } from 'axios';
import type { Except } from 'type-fest';
import { tryCatchAsync } from '../../../../react-commons/utils/tryCatch';

const axiosInstance = axios.create({
    withCredentials: true,
});

export const fetchFn = async <TData = unknown>(
    url: string,
    method: Method = 'GET',
    body?: unknown,
    options?: Except<AxiosRequestConfig, 'url' | 'method' | 'data' | 'withCredentials'>
) => {
    return await tryCatchAsync(async () => {
        const { data } = await axiosInstance.request<TData>({
            ...options,
            url,
            method,
            data: body,
        });

        return data;
    });
};
